import React from 'react';

import visa from 'images/visa.svg';
import masterCard from 'images/masterCard.svg';
import maestro from 'images/maestro.svg';
import cirrus from 'images/cirrus.svg';
import americanExpress from 'images/americanExpress.svg';
import discover from 'images/discover.svg';
import key from 'images/key.svg';

const Warranty = () => (
  <div className="warranty">
    <div className="warranty__inner flex-end">
      <div className="warranty-itm">
        <div className="warranty-itm__img">
          <img src={visa} alt="visa" />
        </div>
      </div>
      <div className="warranty-itm">
        <div className="warranty-itm__img">
          <img src={masterCard} alt="masterCard" />
        </div>
      </div>
      <div className="warranty-itm">
        <div className="warranty-itm__img">
          <img src={maestro} alt="maestro" />
        </div>
      </div>
      <div className="warranty-itm">
        <div className="warranty-itm__img">
          <img src={cirrus} alt="cirrus" />
        </div>
      </div>
      <div className="warranty-itm">
        <div className="warranty-itm__img">
          <img src={americanExpress} alt="americanExpress" />
        </div>
      </div>
      <div className="warranty-itm">
        <div className="warranty-itm__img">
          <img src={discover} alt="discover" />
        </div>
      </div>
      <div className="warranty-separatop" />
      <div className="warranty-itm">
        <div className="warranty-itm__img">
          <img src={key} alt="key" />
        </div>
        <div className="warranty-itm__text">Secure payments</div>
      </div>
    </div>
  </div>
);

export default Warranty;



// WEBPACK FOOTER //
// ./src/components/Warranty/Warranty.js